export const versionAutoSaveTime = 900000; // 15 minutes

export const maxVersionsNumber = 8;
